module.exports = __webpack_public_path__ + "static/bg_pattern_2x-110a9bd244348e59bb22d05153184c8a.png";